const ItemTypes = {
  BLOCK: 'block',
}

export default ItemTypes